class DisplayToggle {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.toggle = self.elem.querySelector('[data-display-toggle]');
        self.showText = self.toggle.getAttribute('data-show-text');
        self.hideText = self.toggle.getAttribute('data-hide-text');
        self.isOpen = false;
    }

    init() {
        let self = this;

        self.toggle.addEventListener('click', evt => {
            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });
    }

    open() {
        let self = this;

        self.elem.classList.add('is-open');
        self.toggle.setAttribute('aria-expanded', true);
        self.toggle.textContent = self.hideText;

        self.isOpen = true;
    }

    close() {
        let self = this;

        self.elem.classList.remove('is-open');
        self.toggle.setAttribute('aria-expanded', false);
        self.toggle.textContent = self.showText;

        self.isOpen = false;
    }
}

export default DisplayToggle;
